<template>
  <div class="simple-table">
    <ElTable ref="table" :data="data" v-loading="loading" border stripe size="mini" :height="height" v-on="$listeners" v-bind="$attrs">
      <template v-for="col in cols">
        <ElTableColumn v-if="col.type" v-bind="col" :key="col.type" align="center"></ElTableColumn>
        <ElTableColumn v-else :key="col.prop" align="center" v-bind="col">
          <template #default="{ row, $index }">
            <slot :name="col.prop" :data="row" :idx="$index">
              {{ row[col.prop] || "-" }}
            </slot>
          </template>
        </ElTableColumn>
      </template>
    </ElTable>
    <div class="st-pagination mt14" v-if="hasPage">
      <ElPagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-size="page.pageSize"
        :layout="layout"
        :total="page.total"
        background
      ></ElPagination>
    </div>
  </div>
</template>
<script>
import { isEmpty } from 'xe-utils';

export default {
  name: "SimpleTable",
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    cols: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Object,
      default: () => ({
        pageNum: 10,
        pageSize: 20,
        total: 0,
      }),
    },
    layout: {
      type: String,
      default: "total, prev, pager, next, jumper",
    },
    hasPage: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: "calc(100% - 56px)"
    },
    defaultSelected: Array
  },
  watch:{
    defaultSelected(val){
      if (isEmpty(val)) {
        this.$refs.table.clearSelection()
      } else if(Array.isArray(val)){
        this.data.forEach(it => {
          if (val.includes(it[this.$attrs.rowKey])) {
            this.$refs.table.toggleRowSelection(it, true)
          }
        });
      }
    }
  },
  methods: {
    handleSizeChange(pageSize) {
      Object.assign(this.page, { pageSize });
      this.$emit("change");
    },
    handleCurrentChange(pageNum) {
      Object.assign(this.page, { pageNum });
      this.$emit("change");
    },
  },
};
</script>
<style lang="scss" scoped>
.simple-table {
  flex: 1;
  padding: 12px 0 12px 12px;
  padding-bottom: 0;
  overflow: hidden;

  .st-pagination {
    display: flex;
    justify-content: center;
  }
}
</style>